import DocumentPreviewList from "pages/project/details/DocumentPreviewList";
import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";

export default function OfferingDocumentTab() {
  const { tabContent } = useProjectDetailsContext();
  return <DocumentPreviewList tabId="offeringDocument" content={tabContent.offeringDocument} />;
}
